import LoadingScreen from "components/loading-screen"
import useMainClass from "hooks/use-main-cass"
import { lazy, Suspense } from "react"
import { Redirect, Route } from "react-router-dom"
import RoutesWithNotFound from "utilities/routes-with-not-found"
import useRouter from 'hooks/use-router'

const Start = lazy(() => import('./views/start'))
const Details = lazy(() => import('./views/details'))
const Ranking = lazy(() => import('./views/ranking'))
const Invite = lazy(() => import('./views/invite'))

export default function GroupsRouter() {
  useMainClass('groups')
  const { query } = useRouter()

  return (
    <Suspense fallback={<LoadingScreen />}>
      <RoutesWithNotFound>
        <Route path="/groups/:type" component={() => <Redirect to={`/groups/${query?.type}/start`} />} exact />
        <Route path="/groups/:type/start" component={Start} exact />
        <Route path="/groups/:type/invite" component={Invite} exact />
        <Route path="/groups/:type/details/:id" component={Details} exact />
        <Route path="/groups/:type/ranking/:id" component={Ranking} exact />
      </RoutesWithNotFound>
    </Suspense>
  )
}